import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Button,
  IconButton,
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';

const ListRow = ({ value, changeValue, deleteRow, columnLabel, placeholder }) => (
  <TableRow>
    <TableCell>
      <TextField fullWidth label={columnLabel} variant="standard" placeholder={placeholder} value={value} onChange={(e) => changeValue(e.target.value)} />
    </TableCell>
    <TableCell>
      <IconButton aria-label="Delete row" onClick={deleteRow}>
        <DeleteIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

export const ListTableCard = ({
  title,
  subheader,
  columnLabel,
  placeholder,
  emptyLabel,
  useJobConfig,
  fieldPath,
}) => {
  const [_list, setList] = useJobConfig(fieldPath);
  const list = _list || [];

  function addRow() {
    setList([...list, '']);
  }
  function deleteRow(i) {
    setList(list.filter((_, idx) => idx !== i));
  }
  function changeValue(i, newValue) {
    setList(list.map((v, idx) => (idx === i ? newValue : v)));
  }

  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{columnLabel}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.length > 0 ? (
              list.map((value, i) => (
                <ListRow
                  key={i}
                  value={value}
                  changeValue={(newValue) => changeValue(i, newValue)}
                  deleteRow={() => deleteRow(i)}
                  columnLabel={columnLabel}
                  placeholder={placeholder}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2}>{emptyLabel}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Button startIcon={<AddIcon />} variant="outlined" onClick={addRow}>
          Add row
        </Button>
      </CardContent>
    </Card>
  );
};
